import { render, staticRenderFns } from "./category-icon.vue?vue&type=template&id=79a4bde8&scoped=true&lang=pug&"
import script from "./category-icon.vue?vue&type=script&lang=js&"
export * from "./category-icon.vue?vue&type=script&lang=js&"
import style0 from "./category-icon.vue?vue&type=style&index=0&id=79a4bde8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a4bde8",
  null
  
)

export default component.exports